// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"pluginModal__toolbar___2ZijD","drawingActions":"pluginModal__drawingActions___2X0n9","extraButtonsWrapper":"pluginModal__extraButtonsWrapper___3R9Sv"};